module.exports = __webpack_public_path__ + "static/media/gb-nir.cbd31ef0.svg";